/* istanbul ignore file */
// ut test has been covered by other hook files
import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import _ from 'underscore';

import {
  AssetWithFoldersDataServiceProvider,
  useAsssetWithFoldersDataService,
} from './asset-with-folders-data-service';

export const useAdsStudioServices = useAsssetWithFoldersDataService;

export const withAdsStudioServicesConsumer = (Comp, pickedPropNames) => {
  const CompWithService = (props) => {
    const dataService = useAdsStudioServices();
    // explicitly pick these props to keep pages' props clean
    let pickedProps = props;
    if (pickedPropNames) {
      pickedProps = _.pick(props, pickedPropNames);
    }
    return (<Comp dataService={dataService} {...pickedProps} />);
  };

  hoistNonReactStatics(CompWithService, Comp);

  return CompWithService;
};

export { AssetWithFoldersDataServiceProvider };
export { useFolders, getAssetTypeToFetch } from './use-folders';
export { useAIGeneratedImages } from './use-ai-generated-images';
export { useFolderPathTree } from './use-folder-path-tree';

// todo: copilot depends on serverContext, should be move to cmui-shell package
// export { withCopilotDataServiceLoaded } from './copilot-data-service';
